<div class="carriers-toolbar">
  <app-business-partner-selector [defaultBusinessPartnerName]="defaultBusinessPartner" (businessPartnerChange)="onBusinessPartnerChange($event)"></app-business-partner-selector>
  <app-provider-selector
    [businessPartnerId]="currentBusinessPartnerId"
    (providerChange)="onProviderChange($event)">
  </app-provider-selector>
  <div class="search" *ngIf="currentMode() === 'mondo'">
    <span class="icon" aria-hidden="true"></span>
    <input type="text"
           [placeholder]="'carriers.search_placeholder' | translate"
           [value]="searchTerm()"
           (input)="onSearchChange($any($event.target).value)" />
    <button
      class="clear"
      *ngIf="searchTerm()"
      type="button"
      aria-label="Clear search"
      title="Clear search"
      (click)="clearSearch()">
      &times;
    </button>
  </div>
  <label class="checkbox" *ngIf="currentMode() === 'mondo'">
    <input type="checkbox" [checked]="showDisabled()" (change)="showDisabled.set($any($event.target).checked)" />
    <span>{{ 'carriers.show_disabled' | translate }}</span>
  </label>
  <button class="button secondary refresh-btn" type="button" *ngIf="currentMode() === 'azuga'" (click)="refreshAzugaCarriers()" [disabled]="azugaLoading()">
    <span class="material-symbols-outlined">refresh</span>
    {{ 'carriers.azuga_refresh' | translate }}
  </button>
  <button class="button primary add-btn" type="button" *ngIf="currentMode() === 'mondo'" (click)="openAddDialog()" [disabled]="currentBusinessPartnerId == null || blockedReason() !== null" [title]="(currentBusinessPartnerId == null ? ('bp_selector.select_business_partner' | translate) : (blockedReason() !== null ? (getBlockedMessageKey() | translate) : null))">
    <span class="material-symbols-outlined">add</span>
    {{ 'carriers.add_carrier' | translate }}
  </button>
</div>

<ng-container *ngIf="currentMode() === 'mondo' && loading(); else tableTpl">{{ 'carriers.loading_carriers' | translate }}</ng-container>

<ng-template #tableTpl>
  <ng-container *ngIf="blockedReason() !== null; else unblockedTpl">
    <div class="carriers-blocked">
      {{ getBlockedMessageKey() | translate }}
    </div>
  </ng-container>
  <ng-template #unblockedTpl>
    <ng-container *ngIf="currentMode() === 'mondo'">
      <ng-container *ngIf="!error(); else errTpl">
    <ng-container *ngIf="(carriers()?.length || 0) === 0; else carriersTable">
      <div class="carriers-empty">
        {{ 'carriers.empty_for_bp' | translate:{ name: currentBusinessPartner } }}
      </div>
    </ng-container>
    <ng-template #carriersTable>
      <table class="carriers-table">
        <thead>
          <tr>
            <th class="sortable"
                (click)="onSort('Name')"
                [attr.aria-sort]="sortKey()==='Name' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'carriers.name' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='Name' && sortDir()==='asc'" [class.desc]="sortKey()==='Name' && sortDir()==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('ApiKey')"
                [attr.aria-sort]="sortKey()==='ApiKey' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'carriers.api_key' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='ApiKey' && sortDir()==='asc'" [class.desc]="sortKey()==='ApiKey' && sortDir()==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('Enabled')"
                [attr.aria-sort]="sortKey()==='Enabled' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'carriers.enabled' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='Enabled' && sortDir()==='asc'" [class.desc]="sortKey()==='Enabled' && sortDir()==='desc'"></span>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of (filteredCarriers() || [])">
            <td>{{ c.Name }}</td>
            <td>{{ c.ApiKey }}</td>
            <td>
              <label class="switch">
                <input type="checkbox" [checked]="c.Enabled" (change)="toggleCarrier(c)" [disabled]="c.enabling"/>
                <span class="slider"></span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="currentMode() === 'azuga'">
      <div class="carriers-loading" *ngIf="azugaLoading()">{{ 'carriers.azuga_loading' | translate }}</div>
      <div class="carriers-empty" *ngIf="!azugaLoading() && azugaError()">{{ 'carriers.azuga_retry_hint' | translate }}</div>
      <div class="carriers-empty" *ngIf="!azugaLoading() && !azugaError() && azugaCarriers().length === 0">{{ 'carriers.azuga_empty' | translate }}</div>
      <table class="carriers-table azuga-table" *ngIf="!azugaLoading() && !azugaError() && azugaCarriers().length > 0">
        <thead>
          <tr>
            <th>{{ 'carriers.azuga_name' | translate }}</th>
            <th>{{ 'carriers.azuga_dot' | translate }}</th>
            <th>{{ 'carriers.azuga_enabled' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let carrier of azugaCarriers()">
            <td>{{ carrier.name }}</td>
            <td>{{ carrier.dot || '-' }}</td>
            <td>
              <label class="switch">
                <input type="checkbox" [checked]="carrier.enabled" (change)="toggleAzugaCarrier(carrier)" [disabled]="carrier.toggling || azugaLoading()"/>
                <span class="slider"></span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #errTpl>
  <div class="error">{{ error() }}</div>
</ng-template>

<app-add-carrier-dialog *ngIf="showAddDialog()" (closed)="closeAddDialog()" (submitCarrier)="onSubmitCarrier($event)" [adding]="adding()" [error]="addError()" />
